import axios from "axios";
import { useMutation } from "react-query";

const login = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}): Promise<string> => {

  const LOGIN_API = "https://tmap-react-api.azurewebsites.net/api/login_api_ci?code=UB567eO9XaxoertVpD1v-f5xlMb7AyT0bSfOSh_nTJHcAzFuLCF3FQ%3D%3D";

  const { data } = await axios.post(
    LOGIN_API,
    { email, password },

    // {
    //   headers: {
    //     "Ocp-Apim-Subscription-Key": process.env.REACT_APP_ML_KEY,
    //   },
    // }
  );

  return data;
};

export function useLogin() {
  const { isLoading, mutateAsync } = useMutation(login);

  return { isLoggingIn: isLoading, login: mutateAsync };
}
